/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji"
import splashAnimation from "./assets/lottie/splashAnimation" // Rename to your file name for custom animation

import socialEngineeringDarija from "./assets/images/books/social-engineering-darija.png"
import quietJourney723 from "./assets/images/books/723-quiet-journey.png"
import whenLifeWasSlow from "./assets/images/books/when-life-was-slow.png"

// Splash Screen
const splashScreen = {
    enabled: true, // set false to disable splash screen
    animation: splashAnimation,
    duration: 2000 // Set animation duration as per your animation
}

// Summary And Greeting Section
const illustration = {
    animated: true // Set to false to use static SVG
}

const greeting = {
    username: "DAOULAT",
    title: "Hi all, I'm Khalil",
    subTitleLines: [
        "Senior Software Engineer 🚀 building scalable, cloud-ready web solutions with Java, Spring Boot, React.js, and AWS.",
        "Founder of 3olba.com — a startup creating SaaS products and delivering website & application solutions for clients.",
        "I care about clean architecture, performance, security, and great user experience."
    ],
    resumeLink:
        "https://drive.google.com/file/d/1JZ26W7sgCNBYM-kltumH1PpB-GtFB7lj/view?usp=sharing",
    displayGreeting: true
};


// Social Media Links
const socialMediaLinks = {
    github: "https://github.com/Vvoox",
    linkedin: "https://www.linkedin.com/in/daoulatkhalil/",
    gmail: "daoulat.khalil@gmail.com",
    stackoverflow: "https://stackoverflow.com/users/10580166/daoulat-khalil",
    // Instagram, Twitter and Kaggle are also supported in the links!
    // To customize icons and social links, tweak src/components/SocialMedia
    display: true // Set true to display this section, defaults to false
}

// Skills Section
const skillsSection = {
    title: "What I do",
    subTitle:
        "Full-stack engineer building enterprise-grade systems with Java/Spring Boot, event-driven microservices, and modern React interfaces — cloud-ready with AWS.",
    skills: [
        emoji(
            "⚡ Build robust RESTful APIs and backend services with Java 17/21 & Spring Boot 3 (Clean Architecture, Security, Performance)."
        ),
        emoji(
            "⚡ Design responsive, accessible frontends with React.js and predictable state management (Redux)."
        ),
        emoji(
            "⚡ Implement event-driven microservices with Kafka + workflow automation using Activiti BPM."
        ),
        emoji(
            "⚡ Build cloud-ready deployments and monitoring foundations on AWS (compute, storage, networking, observability)."
        )
    ],

    /* Make Sure to include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */

    softwareSkills: [
        {
            skillName: "Java",
            fontAwesomeClassname: "fab fa-java"
        },
        {
            skillName: "Spring Boot",
            fontAwesomeClassname: "fas fa-leaf"
        },
        {
            skillName: "JavaScript",
            fontAwesomeClassname: "fab fa-js"
        },
        {
            skillName: "ReactJS",
            fontAwesomeClassname: "fab fa-react"
        },
        {
            skillName: "Docker",
            fontAwesomeClassname: "fab fa-docker"
        },
        {
            skillName: "AWS",
            fontAwesomeClassname: "fab fa-aws"
        }
    ],
    display: true // Set false to hide this section, defaults to true
}

// Education Section
const educationInfo = {
    display: true, // Set false to hide this section, defaults to true
    schools: [
        {
            schoolName: "National School of Applied Sciences",
            logo: require("./assets/images/ensa.png"),
            subHeader: "Master of Science in Computer Science",
            duration: "September 2016 - April 2019",
            desc: "Participated and Achievement in MCPC (Moroccan Collegiate Programming Contest)",
            descBullets: [
                "Familiarity with the core principles of computer science, including algorithms, data structures, " +
                "and operating systems, along with expertise in software engineering encompassing programming, " +
                "databases, and project management."
            ]
        }
    ]
}

// Your top 3 proficient stacks/tech experience
const techStack = {
    viewSkillBars: true, //Set it to true to show Proficiency Section
    experience: [
        {
            Stack: "Backend (Java / Spring Boot)",
            progressPercentage: "90%"
        },
        {
            Stack: "Frontend (React)",
            progressPercentage: "80%"
        },
        {
            Stack: "Cloud (AWS) / DevOps",
            progressPercentage: "60%"
        }
    ],
    displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
}

// Work experience section
const workExperiences = {
    display: true, //Set it to true to show workExperiences Section
    experience: [
        {
            role: "Senior Software Engineer",
            company: "Wafa Assurance",
            companylogo: require("./assets/images/wafa.png"), // add this file or change path to an existing logo
            date: "Mar 2024 – Present",
            desc:
                "Leading full-stack development and technical architecture for the “Sinistre” ecosystem, delivering scalable, maintainable, and high-performance enterprise solutions.",
            descBullets: [
                "Built and maintained robust RESTful APIs using Java 17/21 and Spring Boot 3 (clean architecture, security, reliability).",
                "Designed dynamic and responsive React.js interfaces with Redux for state management and data synchronization.",
                "Integrated Activiti BPM for workflow orchestration and business process automation.",
                "Implemented event-driven communication with Kafka to decouple services and ensure efficient data flow.",
                "Conducted code reviews, mentored engineers, and drove best practices across the team."
            ]
        },
        {
            role: "Senior Software Engineer",
            company: "Societe Generale",
            companylogo: require("./assets/images/sgma.png"),
            date: "Mar 2023 – Mar 2024",
            desc:
                "Created a custom credit management solution (Octroi Crédit) and activity monitoring dashboards for the banking network, with a strong focus on performance, security, and scalability.",
            descBullets: [
                "Collaborated with stakeholders on requirements, design, and delivery of a compliant credit allocation system.",
                "Developed reliable backend services using Java 8 with a clean, maintainable codebase.",
                "Leveraged Spring Cloud and Spring Security for secure, scalable distributed systems.",
                "Adopted microservices architecture to improve modularity, scalability, and flexibility.",
                "Performed continuous performance tuning, refactoring, and security hardening."
            ]
        },
        {
            role: "Software Engineer / Technical Consultant",
            company: "Adria Business & Technology",
            companylogo: require("./assets/images/adria.png"),
            date: "Feb 2022 – Mar 2023",
            desc:
                "Trade Finance missions across multiple banking clients, focused on stability, automation, and deployment excellence.",
            descBullets: [
                "Improved architecture to streamline transaction exchange between the solution and core banking systems.",
                "Integrated Spring Batch to automate generation and transmission of XML transaction files.",
                "Led testing and stabilization activities to ensure robustness in real client environments (UAT/PROD).",
                "Managed deployments and upgrades, ensuring smooth rollouts and production stability."
            ]
        },
        {
            role: "Founder",
            company: "3olba.com",
            companylogo: require("./assets/images/3olba.png"),
            date: "2017 – Present",
            desc:
                "Building web solutions and digital products to help businesses grow.",
            descBullets: [
                "Designing and delivering web platforms end-to-end (product, engineering, deployment).",
                "Driving product strategy, execution, and continuous improvement."
            ]
        }
    ]
}

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */
const openSource = {
    showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
    display: true // Set false to hide this section, defaults to true
}

// Some big projects you have worked on
const bigProjects = {
    title: "Big Projects",
    subtitle: "STARTUPS & PRODUCTS",
    projects: [
        {
            image: require("./assets/images/3olba.png"),
            projectName: "3OLBA (Founder)",
            projectDesc:
                "A SaaS & digital products studio. We build scalable SaaS platforms and deliver end-to-end website and application solutions for clients — from design to development and deployment.",
            footerLink: [
                {
                    name: "Visit Website",
                    url: "https://3olba.com/"
                }
                // you can add extra buttons here.
            ]
        },
        {
            image: require("./assets/images/mysqool.png"), // add this image to assets/images
            projectName: "MySqool",
            projectDesc:
                "MySqool is a cloud-based school and tutoring management platform designed to simplify administration, enhance communication, and improve learning experiences.",
            footerLink: [
                {
                    name: "Visit Website",
                    url: "https://mysqool.com/"
                }
            ]
        }

    ],
    display: true // Set false to hide this section, defaults to true
}

// Achievement Section
const achievementSection = {
    title: emoji("Achievements And Certifications 🏆And Conference "),
    subtitle:
        "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

    achievementsCards: [
        {
            title: "Certificate of Achievement MCPC",
            subtitle: "Moroccan Collegiate Programming Contest",
            image: require("./assets/images/icpc.jpeg"),
            imageAlt: "ICPC Logo",
            footerLink: [{ name: "Certification", url: "" }]
        },
        {
            title: "Participation Certificat",
            subtitle:
                "Conference about Web security , share knowledge and risks to future engineers to give them the chance to know the new features in this domain.",
            image: require("./assets/images/uir.png"),
            imageAlt: "UIR Logo",
            footerLink: [{ name: "Certification", url: "" }]
        },
        {
            title: "Certificate of Gratitude",
            subtitle:
                "Build a CTF event in ENSA FES university , for their students , the aim is share our knowledge in programming and security and bring new technology by challenges each others.",
            image: require("./assets/images/ensaf.jpeg"),
            imageAlt: "ENSAF Logo",
            footerLink: [{ name: "Certification", url: "" }]
        }
    ],
    display: true // Set false to hide this section, defaults to true
}

// Blogs Section
const blogSection = {
    title: "Books",
    subtitle:
        "I enjoy writing and sharing knowledge — from technology and cybersecurity to reflections on life and creativity.",
    displayMediumBlogs: "false",
    blogs: [
        {
            url: "https://www.researchgate.net/publication/349297753_Social_engineering_Arabic_Darija_Version",
            title: "Social Engineering (Arabic Darija Version)",
            description:
                "A technical exploration of linguistic-based social engineering, showing how Moroccan dialects can be leveraged in cybersecurity.",
            image: socialEngineeringDarija
        },
        {
            url: "https://www.amazon.in/Quiet-Journey-Routine-Growth-Meaning-ebook/dp/B0FFJJ26DN/",
            title: "7:23 — A Quiet Journey of Routine, Growth, and Meaning",
            description:
                "A reflective Kindle book about routine, personal growth, and meaning.",
            image: quietJourney723
        },
        {
            url: "https://www.amazon.in/When-Life-Was-Slow-forgot-ebook/dp/B0FFT23Y2C",
            title: "When Life Was Slow (and We Forgot)",
            description:
                "A reflective and creative eBook exploring life, memory, and human connection.",
            image: whenLifeWasSlow
        }
    ],
    display: true
}



// Talks Sections
const talkSection = {
    title: "TALKS",
    subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

    talks: [
        {
            title: "Build Actions For Google Assistant",
            subtitle: "Codelab at GDG DevFest Karachi 2019",
            slides_url: "https://bit.ly/saadpasta-slides",
            event_url: "https://www.facebook.com/events/2339906106275053/"
        }
    ],
    display: false // Set false to hide this section, defaults to true
}

// Podcast Section
const podcastSection = {
    title: emoji("Podcast 🎙️"),
    subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

    // Please Provide with Your Podcast embeded Link
    podcast: [
        "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
    ],
    display: false // Set false to hide this section, defaults to true
}

const contactInfo = {
    title: emoji("Contact Me ☎️"),
    subtitle: "Discuss a project or just want to say hi? My Inbox is open for all."
    // email_address: "daoulat.khalil@gmail.com"
}

// Twitter Section
const twitterDetails = {
    userName: "twitter", //Replace "twitter" with your twitter username without @
    display: false // Set true to display this section, defaults to false
}

const isHireable = false // Set false if you are not looking for a job.

export {
    illustration,
    greeting,
    socialMediaLinks,
    splashScreen,
    skillsSection,
    educationInfo,
    techStack,
    workExperiences,
    openSource,
    bigProjects,
    achievementSection,
    blogSection,
    talkSection,
    podcastSection,
    contactInfo,
    twitterDetails,
    isHireable
}
